import MessagesListContainer from './message_list_container';

const MessagesList = MessagesListContainer;
export default MessagesList;
